module.exports = __webpack_public_path__ + "static/media/event02.7b167f4f.jpg";